import React, { useState, useEffect } from 'react';
import BrowserView from './BrowserView';
import './BrowserOnly.css';

function BrowserOnly() {
  const [url, setUrl] = useState('https://fideantech.com');

  // Ensure browser view is properly initialized
  useEffect(() => {
    // Small delay to ensure DOM is ready
    const timer = setTimeout(() => {
      if (window.electronAPI && window.electronAPI.loadExternalURL) {
        // Trigger initial load
        const container = document.querySelector('.browser-only-content .browser-view-card');
        if (container) {
          const rect = container.getBoundingClientRect();
          const urlBarHeight = document.querySelector('.browser-url-bar-top-wrapper')?.getBoundingClientRect().height || 0;
          
          window.electronAPI.loadExternalURL(url, {
            x: Math.round(rect.left),
            y: Math.round(rect.top + urlBarHeight),
            width: Math.round(rect.width),
            height: Math.round(rect.height - urlBarHeight)
          });
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [url]);

  return (
    <div className="browser-only-container">
      <div className="browser-only-header">
        <h1>🌐 Secure Browser</h1>
        <p>Access social media and websites with session persistence</p>
      </div>
      <div className="browser-only-content">
        <BrowserView url={url} setUrl={setUrl} />
      </div>
    </div>
  );
}

export default BrowserOnly; 